<!-- eslint-disable no-new -->
<script setup lang="ts">
  import { Modal } from 'bootstrap'
  import IconComponent from '../../../components/Atoms/Icon.vue'
  import { useAR } from '@/store/Pinia/useAR.store'
  import { useModalControl } from '../store/pinia/useModalControl.store'
  import usePluginDownloadModal from '../composables/usePluginDownloadModal'

  import { ref, onMounted } from 'vue'

  const modalControlStore = useModalControl()
  const { showPluginDownloadModal, hidePluginDownloadModal } =
    usePluginDownloadModal()

  const modal = ref<InstanceType<typeof Modal> | null>(null)
  const arStore = useAR()

  onMounted(() => {
    modal.value = new Modal('#modal-plugin-not-executing', {
      backdrop: 'static',
      keyboard: false,
    })
  })

  function show() {
    modal.value?.show()
  }

  function hide() {
    modal.value?.hide()
  }

  function verifyPluginAgain() {
    modalControlStore.show({
      modalId: 'pluginDownloadModal',
      show: showPluginDownloadModal,
      hide: hidePluginDownloadModal,
    })
  }

  defineExpose({ show, hide })
</script>

<template>
  <div
    id="modal-plugin-not-executing"
    class="modal modal-md fade"
    tabindex="-1"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header pb-3">
          <h5 class="modal-title">Atenção!</h5>

          <button
            class="btn-close"
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="hide"
          />
        </div>
        <div class="modal-body py-3">
          <img alt="sucesso" src="../assets/worried-girl.svg" />

          <p class="fs-6 text-start mt-4">
            <strong
              >Parece que o plugin não está em execução em seu
              computador.</strong
            >
          </p>

          <p class="fs-6 text-start mt-4">
            Para emitir seu Certificado, certifique-se de que ele está em
            execução.
          </p>

          <p class="fs-6 text-center mt-4">
            <strong>Não sabe executar o plugin?</strong>

            <a
              href="../faq/digital-certificate-plugin"
              target="_blank"
              rel="noopener noreferrer"
              class="link ms-2"
            >
              <span class="me-2">Clique aqui</span>
              <icon-component name="up-right-from-square" />
            </a>
          </p>

          <div class="contact-wrapper">
            <div class="contact py-3">
              <div class="contact-item">
                <span class="color--primary fw-600">
                  Ficou alguma dúvida?
                </span>
              </div>
              <div class="contact-item">
                <icon-component class="icon mx-1" name="phone" />
                <span>{{ arStore.$state.arData.foneAR }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer py-3">
          <button
            class="btn btn-primary"
            type="button"
            @click="verifyPluginAgain"
          >
            Tentar novamente
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .modal-title {
    color: red;
  }

  @media (min-width: 576px) {
    .modal-md {
      --bs-modal-width: 440px;
    }
  }

  .link {
    font-size: 1rem;
    font-weight: 400;
    color: #0080a3;
    cursor: pointer;
  }

  .link:hover {
    text-decoration: underline;
  }

  .contact-wrapper {
    display: flex;
    justify-content: center;
    margin-top: 2rem;
    width: 100%;
  }
  .contact {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    gap: 1rem;
    border: 1px solid #e6e7ec;
    border-radius: 10px;
  }
  .contact-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
</style>
